export default "__VITE_ASSET__BDhkV2ck__"